import {
  getBreakpoints,
  viewportSize
} from './utils.js'


let enableConsoleLogs = true
let logger = (...msg) => enableConsoleLogs && console.log(...msg)


export default class LangMenu {
  constructor() {
    this.headerNav = document.querySelector('#header-nav')
    this.langList = document.querySelector('[data-lang-menu]')
    this.navBreakpoints = getBreakpoints(this.headerNav)

    let hasMultipleLangs = !!this.langList
    let isLgViewport = viewportSize(this.navBreakpoints.sm, this.navBreakpoints.lg).isLg.matches

    if (hasMultipleLangs) {
      this.langListParent = document.querySelector('#lang-list-wrapper')

      // Listen for viewport change events from the nav menu, as this script’s setup
      // depends on nav menu changes being done
      this.headerNav.addEventListener('navmenu', this.handleNavMenuChange.bind(this))
    }

    if (hasMultipleLangs && isLgViewport) {
      this.setup()
    }
  }

  handleNavMenuChange(event) {
    if (event.detail.isSetup) {
      this.destroy()
    } else {
      // Reassign these as the original references have been lost:
      this.langList = document.querySelector('[data-lang-menu]')
      this.langListParent = document.querySelector('#lang-list-wrapper')
      this.setup()
    }
  }

  setup() {
    let currentLangname = this.langList.dataset.langCurrent

    // Create menu
    this.langMenu = document.createElement('div')
    this.langMenu.id = 'lang-menu'
    this.langMenu.classList.add('lang-menu')
    this.langMenu.setAttribute('hidden', 'true')

    // Create lang menu toggle button
    this.langMenuBtn = document.createElement('button')
    this.langMenuBtn.classList.add('btn', 'lang-menu-toggle')
    this.langMenuBtn.setAttribute('aria-controls', 'lang-menu')
    this.langMenuBtn.setAttribute('aria-expanded', 'false')
    this.langMenuBtn.innerHTML = `<svg class="icon" xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path fill="currentColor" d="m476-80 182-480h84L924-80h-84l-43-122H603L560-80h-84ZM160-200l-56-56 202-202q-35-35-63.5-80T190-640h84q20 39 40 68t48 58q33-33 68.5-92.5T484-720H40v-80h280v-80h80v80h280v80H564q-21 72-63 148t-83 116l96 98-30 82-122-125-202 201Zm468-72h144l-72-204-72 204Z"/></svg> ${currentLangname}`

    // Add them in
    this.langMenu.appendChild(this.langList)
    this.langListParent.appendChild(this.langMenuBtn)
    this.langListParent.appendChild(this.langMenu)
    this.langList.setAttribute('data-lang-menu', true)

    this.langMenuBtn.addEventListener('click', this.menuToggle.bind(this))
    document.addEventListener('click', this.closeMenu.bind(this))
    document.addEventListener('keyup', this.closeMenu.bind(this))
  }

  destroy() {
    this.langMenuBtn.removeEventListener('click', this.menuToggle.bind(this))
    document.removeEventListener('click', this.closeMenu.bind(this))
    document.removeEventListener('keyup', this.closeMenu.bind(this))

    this.langList.setAttribute('data-lang-menu', false)
    this.langListParent.appendChild(this.langList)
    this.langMenuBtn.remove()
    this.langMenu.remove()
  }

  menuToggle() {
    this.langMenu.hidden = !this.langMenu.hidden
    this.langMenuBtn.setAttribute('aria-expanded', !this.langMenu.hidden)
  }

  closeMenu(event) {
    let isOutsideMenu = !event.target.closest('#lang-list-wrapper')
    let isMenuShown = !this.langMenu.hidden
    let isFocusInMenu = document.activeElement.closest('#lang-list-wrapper')

    if (event.type === 'click' && isOutsideMenu && isMenuShown) {
      this.menuToggle()
    }

    if (event.key === 'Escape' && isMenuShown) {
      this.menuToggle()
      this.langMenuBtn.focus()
    }

    if (event.key === 'Tab' && !isFocusInMenu && isMenuShown) {
      this.menuToggle()
    }
  }
}
